'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'clsx';
import { Canvas } from '~/webgl/components/canvas';
import { Banner } from '../banner';
import { Footer } from '../footer';
import { Lenis } from '../lenis';
export function Wrapper(t0) {
  const $ = _c(22);
  let children;
  let className;
  let props;
  let t1;
  let webgl;
  if ($[0] !== t0) {
    const {
      children: t2,
      theme,
      className: t3,
      lenis: t4,
      webgl: t5,
      ...t6
    } = t0;
    children = t2;
    className = t3;
    t1 = t4;
    webgl = t5;
    props = t6;
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = webgl;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    webgl = $[5];
  }
  const lenis = t1 === undefined ? true : t1;
  let t2;
  if ($[6] !== webgl) {
    t2 = webgl && <Canvas root={true} {...typeof webgl === "object" && webgl} />;
    $[6] = webgl;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== className) {
    t3 = cn("relative grow px-safe overflow-x-clip z-10", className);
    $[8] = className;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Banner />;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Footer />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== props || $[14] !== t3) {
    t6 = <main className={t3} {...props}>{t4}{children}{t5}</main>;
    $[12] = children;
    $[13] = props;
    $[14] = t3;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== lenis) {
    t7 = lenis && <Lenis root={true} options={typeof lenis === "object" ? lenis : {}} />;
    $[16] = lenis;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t2 || $[19] !== t6 || $[20] !== t7) {
    t8 = <>{t2}{t6}{t7}</>;
    $[18] = t2;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}